<template>
	<div class="breakdown-container">
		<ModalHeader :title="getString('payments_breakdown')" />
		<AppList :items="items" />
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";

export default {
	setup() {
		const currencyStore = useCurrencyStore();
		const languageStore = useLanguageStore();
		return {currencyStore, getString: languageStore.getString};
	},
	name: "QromoReportBreakdown",
	components: {ModalHeader, AppList},
	props: {
		breakdown: {
			type: Object,
			required: true
		}
	},
	computed: {
		items() {
			return Object.entries(this.breakdown).map(([key, value]) => {
				return {
					title: this.getString(key),
					rightText: this.currencyStore.readableCurrencyValue(value,false),
					rightPrimaryText: true,
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">

</style>